const useCF = (new URLSearchParams(window.location.search)).get('ws-cf') === '1';
// Cloudflare isn't used by default anymore
module.exports = {
    apiServerUrl: 'https://api.amplement.io',
    publicHostname: 'https://www.amplement.com',
    websocketHostname: useCF ? 'https://api.amplement.io' : 'https://api.amplement.com',
    debug: false,
    logLevel: 'warn',
};
